import type { Tables } from '@magicschool/supabase/types';
import { PROFILE_BUILDER_STEPS, type StepVariant } from './constants';
import { SUPPORTED_COUNTRIES } from './selectorComponents/util';

export const shouldShowGrades = (selectedProfession?: Tables<'professions'>, countryCode?: string) => {
  if (!selectedProfession?.collect_grade_data) return false;
  if (!countryCode || !SUPPORTED_COUNTRIES.includes(countryCode)) return false;
  return true;
};

type GetStepParams = {
  selectedProfession?: Tables<'professions'>;
  countryCode?: string;
  planId?: number;
};

type StepData = {
  getNextStep: (params: GetStepParams) => StepVariant;
  getPreviousStep: (params: GetStepParams) => StepVariant;
};

export const stepDataMap: Record<StepVariant, StepData> = {
  [PROFILE_BUILDER_STEPS.WELCOME]: {
    getNextStep: () => PROFILE_BUILDER_STEPS.PROFESSION,
    getPreviousStep: () => PROFILE_BUILDER_STEPS.WELCOME,
  },
  [PROFILE_BUILDER_STEPS.PROFESSION]: {
    getNextStep: ({ selectedProfession, countryCode = 'US', planId }) =>
      planId !== 3
        ? PROFILE_BUILDER_STEPS.LOCATION
        : shouldShowGrades(selectedProfession, countryCode)
          ? PROFILE_BUILDER_STEPS.GRADES
          : selectedProfession?.collect_subject_data
            ? PROFILE_BUILDER_STEPS.SUBJECTS
            : PROFILE_BUILDER_STEPS.NAME,
    getPreviousStep: () => PROFILE_BUILDER_STEPS.WELCOME,
  },
  [PROFILE_BUILDER_STEPS.LOCATION]: {
    getNextStep: ({ selectedProfession, countryCode = 'US' }) =>
      shouldShowGrades(selectedProfession, countryCode)
        ? PROFILE_BUILDER_STEPS.GRADES
        : selectedProfession?.collect_subject_data
          ? PROFILE_BUILDER_STEPS.SUBJECTS
          : PROFILE_BUILDER_STEPS.NAME,
    getPreviousStep: () => PROFILE_BUILDER_STEPS.PROFESSION,
  },
  [PROFILE_BUILDER_STEPS.GRADES]: {
    getNextStep: ({ selectedProfession }) =>
      selectedProfession?.collect_subject_data ? PROFILE_BUILDER_STEPS.SUBJECTS : PROFILE_BUILDER_STEPS.NAME,
    getPreviousStep: ({ planId }) => (planId !== 3 ? PROFILE_BUILDER_STEPS.LOCATION : PROFILE_BUILDER_STEPS.PROFESSION),
  },
  [PROFILE_BUILDER_STEPS.SUBJECTS]: {
    getNextStep: () => PROFILE_BUILDER_STEPS.NAME,
    getPreviousStep: ({ selectedProfession, countryCode = 'US', planId }) =>
      shouldShowGrades(selectedProfession, countryCode)
        ? PROFILE_BUILDER_STEPS.GRADES
        : planId !== 3
          ? PROFILE_BUILDER_STEPS.LOCATION
          : PROFILE_BUILDER_STEPS.PROFESSION,
  },
  [PROFILE_BUILDER_STEPS.NAME]: {
    getNextStep: () => PROFILE_BUILDER_STEPS.BEST_PRACTICES,
    getPreviousStep: ({ selectedProfession, planId }) =>
      selectedProfession?.collect_subject_data
        ? PROFILE_BUILDER_STEPS.SUBJECTS
        : selectedProfession?.collect_grade_data
          ? PROFILE_BUILDER_STEPS.GRADES
          : planId !== 3
            ? PROFILE_BUILDER_STEPS.LOCATION
            : PROFILE_BUILDER_STEPS.PROFESSION,
  },
};
